export default function AuthGateAction({ as: Component = 'button', onClick, gateAction, authMessage, children, ...props }) {
    const handleClick = gateAction(onClick || (() => {}), authMessage);
    return <Component {...props} onClick={handleClick}>{children}</Component>;
}
